import React from 'react';
import PropTypes from 'prop-types';
import {Rnd as RndBox} from 'react-rnd';
import './assets/CropImageComponentStyle.css';
import t from '../i18n/I18n';

export default class CropImageComponent extends React.Component {
  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    scale: PropTypes.number.isRequired,
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
    onDrag: PropTypes.func,
    onResize: PropTypes.func,
    onCropResizeStop: PropTypes.func,
  };

  static defaultProps = {
    offsetX: 0,
    offsetY: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      componentReady: false,
      displayOverlay: false,
      selection: {
        x: 0,
        y: 0,
        width: props.width * props.scale * 0.6,
        height: props.height * props.scale * 0.6,
      },
    };

    this.onResize = this.onResize.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.toggleOverlayDisplay = this.toggleOverlayDisplay.bind(this);
    this.onResizeStop = this.onResizeStop.bind(this);
  }

  componentDidMount() {
    this.setState({componentReady: true});
    this.memorizePrevXY();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.scale !== this.props.scale) {
      this.setState({
        selection: {
          x: this.prevSelectionX * newProps.scale,
          y: this.prevSelectionY * newProps.scale,
          width: this.prevSelectionW * newProps.scale,
          height: this.prevSelectionH * newProps.scale,
        },
      });
      this.refs.box.draggable.setState({
        x: this.prevSelectionX * newProps.scale,
        y: this.prevSelectionY * newProps.scale,
      });
    }
  }

  getSelection() {
    return {
      x: this.refs.box.draggable.state.x,
      y: this.refs.box.draggable.state.y,
      width: this.refs.box.resizable.state.width,
      height: this.refs.box.resizable.state.height,
    };
  }

  onResize() {
    this.setState({selection: this.getSelection()});
    this.memorizePrevXY();
    if (this.props.onResize) this.props.onResize();
  }

  onDrag() {
    this.setState({selection: this.getSelection()});
    this.memorizePrevXY();
    if (this.props.onDrag) this.props.onDrag();
  }

  memorizePrevXY() {
    this.prevSelectionX = this.state.selection.x / this.props.scale;
    this.prevSelectionY = this.state.selection.y / this.props.scale;
    this.prevSelectionW = this.state.selection.width / this.props.scale;
    this.prevSelectionH = this.state.selection.height / this.props.scale;
  }

  drawResizeEdges() {
    return (
      <div>
        <span
          style={{
            width: '8px',
            height: '8px',
            position: 'absolute',
            top: '-4px',
            left: '-4px',
            background: '#FFF',
            border: '1px solid #000',
          }}
        />
        <span
          style={{
            width: '8px',
            height: '8px',
            position: 'absolute',
            top: '-4px',
            left: 'calc(50% - 4px)',
            background: '#FFF',
            border: '1px solid #000',
          }}
        />
        <span
          style={{
            width: '8px',
            height: '8px',
            position: 'absolute',
            top: '-4px',
            right: '-4px',
            background: '#FFF',
            border: '1px solid #000',
          }}
        />
        <span
          style={{
            width: '8px',
            height: '8px',
            position: 'absolute',
            top: 'calc(50% - 4px)',
            right: '-4px',
            background: '#FFF',
            border: '1px solid #000',
          }}
        />
        <span
          style={{
            width: '8px',
            height: '8px',
            position: 'absolute',
            top: 'calc(100% - 5px)',
            right: '-4px',
            background: '#FFF',
            border: '1px solid #000',
          }}
        />
        <span
          style={{
            width: '8px',
            height: '8px',
            position: 'absolute',
            bottom: '-4px',
            right: 'calc(50% - 4px)',
            background: '#FFF',
            border: '1px solid #000',
          }}
        />
        <span
          style={{
            width: '8px',
            height: '8px',
            position: 'absolute',
            top: 'calc(100% - 5px)',
            left: '-4px',
            background: '#FFF',
            border: '1px solid #000',
          }}
        />
        <span
          style={{
            width: '8px',
            height: '8px',
            position: 'absolute',
            top: 'calc(50% - 4px)',
            left: '-4px',
            background: '#FFF',
            border: '1px solid #000',
          }}
        />
      </div>
    );
  }

  drawCroppingDimensions() {
    return (
      <div style={styles.croppingDimensions}>
        <div style={styles.dimensionsOverlay}>
          <span style={styles.dimensionsOverlayText}>
            x: {Math.floor(this.state.selection.x / this.props.scale)}
          </span>
          <span style={styles.dimensionsOverlayText}>
            y: {Math.floor(this.state.selection.y / this.props.scale)}
          </span>
          <span style={styles.dimensionsOverlayText}>
            {t('WIDTH')}: {Math.floor(this.state.selection.width / this.props.scale)}
          </span>
          <span style={styles.dimensionsOverlayText}>
            {t('HEIGHT')}: {Math.floor(this.state.selection.height / this.props.scale)}
          </span>
        </div>
      </div>
    );
  }

  toggleOverlayDisplay() {
    this.setState({displayOverlay: !this.state.displayOverlay});
  }

  onResizeStop() {
    const {onCropResizeStop} = this.props;
    onCropResizeStop();
  }

  render() {
    const containerStyle = {
      position: 'absolute',
      top: this.props.offsetY,
      left: this.props.offsetX,
      width: this.props.width * this.props.scale,
      height: this.props.height * this.props.scale,
      zIndex: '1',
    };

    let topOuterBlock, rightOuterBlock, bottomOuterBlock, leftOuterBlock;
    if (this.state.componentReady) {
      const selection = this.getSelection();

      topOuterBlock = {
        ...styles.outerBlock,
        width: selection.width,
        height: selection.y,
        top: 0,
        left: selection.x,
      };
      let rightBlockHeight = this.props.width * this.props.scale - (selection.x + selection.width);
      if (rightBlockHeight < 0) rightBlockHeight = 0;
      rightOuterBlock = {
        ...styles.outerBlock,
        width: rightBlockHeight,
        height: '100%',
        top: 0,
        right: 0,
      };
      let bottomBlockHeight =
        this.props.height * this.props.scale - (selection.y + selection.height);
      if (bottomBlockHeight < 0) bottomBlockHeight = 0;
      bottomOuterBlock = {
        ...styles.outerBlock,
        width: selection.width,
        height: bottomBlockHeight,
        bottom: 0,
        left: selection.x,
      };
      leftOuterBlock = {
        ...styles.outerBlock,
        width: selection.x,
        height: '100%',
        bottom: 0,
        left: 0,
      };
    }

    return (
      <div className="CropContainer" style={containerStyle}>
        <RndBox
          ref="box"
          default={{...this.state.selection}}
          minWidth={80}
          minHeight={55}
          bounds="parent"
          onDrag={this.onDrag}
          onResize={this.onResize}
          onResizeStop={this.onResizeStop}>
          <div
            className="CropImageInner"
            style={{
              borderImage: 'url(images/selection.gif) 1 round round',
            }}
            onMouseDown={this.toggleOverlayDisplay}
            onMouseUp={this.toggleOverlayDisplay}>
            {this.drawResizeEdges()}
            {this.state.displayOverlay ? this.drawCroppingDimensions() : null}
          </div>
        </RndBox>
        {this.state.componentReady ? (
          <div>
            <div style={topOuterBlock} />
            <div style={rightOuterBlock} />
            <div style={bottomOuterBlock} />
            <div style={leftOuterBlock} />
          </div>
        ) : null}
      </div>
    );
  }
}

const styles = {
  outerBlock: {
    position: 'absolute',
    overflow: 'hidden',
    display: 'block',
    backgroundColor: '#000',
    opacity: 0.5,
    zIndex: 0,
  },
  croppingDimensions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  dimensionsOverlay: {
    background: 'rgba(255, 255, 255, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    padding: '5px',
  },
  dimensionsOverlayText: {
    fontSize: '10px',
    fontWeight: '600',
    letterSpacing: '1px',
  },
};
